import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { useThemeUI } from '@theme-ui/core';
import { defaultBreakpoints } from '@theme-ui/css';

var useBreakpointIndex = function useBreakpointIndex() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = useThemeUI();
  var _options$defaultIndex = options.defaultIndex,
      defaultIndex = _options$defaultIndex === void 0 ? 0 : _options$defaultIndex;
  var breakpoints = context.theme && context.theme.breakpoints || defaultBreakpoints;

  if (typeof defaultIndex !== 'number') {
    throw new TypeError("Default breakpoint index should be a number. Got: ".concat(defaultIndex, ", ").concat(typeof defaultIndex));
  } else if (defaultIndex < 0 || defaultIndex > breakpoints.length - 1) {
    throw new RangeError("Default breakpoint index out of range. Theme has ".concat(breakpoints.length, " breakpoints, got index ").concat(defaultIndex));
  }

  var _useState = useState(defaultIndex),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    var getIndex = function getIndex() {
      return breakpoints.filter(function (bp) {
        return window.matchMedia("screen and (min-width: ".concat(bp, ")")).matches;
      }).length;
    };

    var onResize = function onResize() {
      var newValue = getIndex();

      if (value !== newValue) {
        setValue(newValue);
      }
    };

    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [breakpoints, value]);
  return value;
};

function useResponsiveValue(values) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var array = typeof values === 'function' ? values(theme) : values;
  var index = useBreakpointIndex(options);
  return array[index >= array.length ? array.length - 1 : index];
}

export { useBreakpointIndex, useResponsiveValue };